"use client";
import { createContext, PropsWithChildren, useContext, useState } from "react";

import { Locale } from "../constants";

type LocaleContextType = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};

const LocaleContext = createContext<LocaleContextType>({
  locale: null!,
  setLocale: () => {},
});

type Props = {
  locale: Locale;
};

export default function LocaleProvider(props: PropsWithChildren<Props>) {
  const [locale, setLocale] = useState<Locale>(props.locale);
  const { children } = props;

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  return useContext(LocaleContext);
}
